/**
 * `<slide-show>` custom element (feature list v1.2).
 *
 * The track is native CSS scroll-snap: swipe and trackpad already work
 * without this file. Here only the arrows come to life — hidden until JS
 * runs, they scroll the track one viewport at a time.
 */
class SlideShow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slideshow-track]');
    const prev = this.querySelector('[data-slideshow-prev]');
    const next = this.querySelector('[data-slideshow-next]');
    if (!this.track || !prev || !next) return;

    prev.hidden = false;
    next.hidden = false;
    const smooth = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    const behavior = smooth ? 'smooth' : 'auto';
    prev.addEventListener('click', () => {
      this.track.scrollBy({ left: -this.track.clientWidth, behavior });
    });
    next.addEventListener('click', () => {
      this.track.scrollBy({ left: this.track.clientWidth, behavior });
    });
  }
}

if (!customElements.get('slide-show')) {
  customElements.define('slide-show', SlideShow);
}
